import { getFirstLetter } from "../utils/string";
import RedirectProfile from "./common/RedirectProfile";

// // GS-4 Start
type Props = {
  rootClass?: string;
  className?: string;
  img?: string | null;
  id?: number;
  name?: string | null;
};

const defaultImg =
  "https://s3.ap-south-1.amazonaws.com/cdn-shebaxyz/images/profiles/avatar/default.jpg";

export default function ProfileImage({
  rootClass = "",
  className = "",
  img,
  id,
  name,
}: Props) {
  const isImg = img && img !== defaultImg;

  return (
    <RedirectProfile id={id}>
      <div className={`w-24 h-24 ${rootClass}`}>
        {isImg ? (
          <img
            className={`w-full h-full rounded-full object-cover ${className}`}
            src={img}
            alt=""
          />
        ) : !!name ? (
          <div
            className={`w-full h-full flex justify-center items-center text-center rounded-full bg-primary/10 text-primary font-medium text-2xl ${className}`}
          >
            {getFirstLetter(name)}
          </div>
        ) : (
          <img
            className={`w-full h-full rounded-full object-cover ${className}`}
            src={defaultImg}
            alt=""
          />
        )}
      </div>
    </RedirectProfile>
  );
}
